import React, { useRef, useState, useEffect } from "react";
import { useSpeechSynthesis } from "react-speech-kit";
import { TextField, InputAdornment } from "@mui/material";

import SendButton from "../Images/send_button.png";
import video_1 from "../videos/video_1.mp4";
import video_2 from "../videos/video_2.mp4";
import video_3 from "../videos/video_3.mp4";
import video_4 from "../videos/video_4.mp4";
import video_5 from "../videos/video_5.mp4";

import { setVideoIndexId, getVideoIndexId, postRequest, getVisitId, getUser, } from "../Services/DataMode";

function videoLoop(props) {
  const [vidIndex, setVidIndex] = useState(0);
  const [videoSource, setVideoSource] = useState(video_1); // Set default video
  var videos = [video_5];

  useEffect(() => {
    let index = getVideoIndexId();
    // postRequest(
    //   "ws_webrtc/telemed.asmx/GetNewVideo_AUS_IRE_UK",
    //   { sKey: getUser(), iVisitId: getVisitId() },
    //   (response) => {
    //     // console.log(response, "Video213");
    //     if (response.d.status) {
    //       // console.log(response.d.status, "newvideo");
    //       setVideoSource(video_4);
    //     }
    //     else {
          // setVideoSource(video_1);
          if (index >= 0 && index < videos.length) {
            setVidIndex(index);
            setVideoIndexId((index + 1) % videos.length);
          }
          else {
            setVidIndex(0);
            setVideoIndexId(1);
          }
    //     }
    //   },
    // );
  }, []);

  const handleVideoEnd = () => {
    if (vidIndex + 1 < videos.length) {
      setVidIndex(vidIndex + 1);
    }
    else {
      setVidIndex(0);
    }
  };

  return (
    <video
      controls
      autoPlay
      muted
      width="100%"
      height="100%"
      src={videos[vidIndex]}
      onEnded={handleVideoEnd}
    /> //idx + 1)} />
  );
}

export default videoLoop;